import React from 'react';
import PropTypes from 'prop-types';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Scheduler from '../utils/Scheduler';
import DateRange from '../utils/DateRange';
import Button from '@material-ui/core/Button';
import SwipeableViews from 'react-swipeable-views';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';

import moment from 'moment';
import 'moment/locale/fr';

import { compose, withProps } from "recompose"
import { withGoogleMap, GoogleMap, DirectionsRenderer, Marker } from "react-google-maps"
import LocationSearchInput from "../utils/LocationSearchInput";
import {ValidatorForm} from "react-material-ui-form-validator";
import FormControl from "@material-ui/core/FormControl/FormControl";
import Picker from "../utils/Picker";
import {NavLink} from "react-router-dom";
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";

import params from "../../utils/params"

moment.locale('fr');

const styles = theme => ({
    map: {
        width: "100%",
        height: "100%",
        overflow: 'hidden',
    },
    form: {
        width: '100%', // Fix IE11 issue.
        maxWidth: "250px",
        marginTop: theme.spacing.unit,
    },
    inline: {
        display: 'inline',
    },
    fab: {
        position: 'absolute',
        paddingLeft: 5,
        bottom: theme.spacing.unit * 14,
        right: theme.spacing.unit,
        zIndex: 999
    },
    extendedIcon: {
        marginRight: 5,
    },
    legend: {
        position: 'absolute',
        top: theme.spacing.unit * 10,
        right: theme.spacing.unit * 2,
        zIndex: 999
    },
    image: {
        width: "auto",
        height: 35
    },
    imageMore: {
        width: "100%",
        height: "auto"
    },
    list: {
        width: '100%',
        maxWidth: 360,
        maxHeight: 450,
        overflowX: "auto",
        backgroundColor: theme.palette.background.paper,
    },
    selected:{
        backgroundColor: "#ccc",
    },
    button: {
        margin: theme.spacing.unit,
    },
    divSwip: {
       overflow: "hidden",
    },
});

const MyMapComponent = compose(
    withProps({
        googleMapURL: "https://maps.googleapis.com/maps/api/js?key=" + params.GOOGLE_KEY + "&v=3.exp&libraries=geometry,drawing,places",
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `400px` }} />,
        mapElement: <div style={{ height: `100%` }} />,
    }),
    withGoogleMap,
)((props) =>
    <GoogleMap
        ref={props.mapParcours}
        zoom={parseFloat(props.zoom)}
        center={{ lat: parseFloat(props.lat), lng: parseFloat(props.lng) }}
        onCenterChanged={props.onCenterChanged}
        onZoomChanged={props.onZoomChanged}
    >
        {!props.directions ? (
                <div>
            {props.audits.map(audit=>{
                return <Marker
                    key={audit.id}
                    position={{ lat: parseFloat(audit.latitude), lng: parseFloat(audit.longitude) }}
                    onClick={(e) => props.onMarkerClick(audit)}
                    icon={{
                        url: (props.audit_selected === audit.id) ? "https://maps.google.com/mapfiles/ms/icons/red-dot.png" : "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",
                    }}
                />
            })
        }
                </div>
        ) : (
            <div>
                <DirectionsRenderer
                    directions={props.directions}
                    options={{
                        polylineOptions: {
                            editable: false,
                            draggable: false,
                            clickable: false,
                            strokeColor: '#FF4E00',
                            strokeOpacity: 0.5,
                            strokeWeight: 10
                        }
                    }}
                />
                {/*<DirectionsRenderer
                    directions={props.directions2}
                    options={{
                        polylineOptions: {
                            editable: false,
                            draggable: false,
                            clickable: false,
                            strokeColor: '#3dff1c',
                        }
                    }}
                />*/}
            </div>
        )}
        {/*<TrafficLayer autoUpdate />*/}
    </GoogleMap>
)


class Parcours extends React.PureComponent {

    componentWillReceiveProps(nextProps) {
        //
    }

    getInfoBetweenPoints(from, to){
        const DirectionsService = new window.google.maps.DirectionsService();
        DirectionsService.route({
            origin: new window.google.maps.LatLng(from.latitude, from.longitude),
            destination: new window.google.maps.LatLng(to.latitude, to.longitude),
            travelMode: window.google.maps.TravelMode.DRIVING,
            provideRouteAlternatives: false,
            optimizeWaypoints: false,
        }, (result, status) => {
            if (status === window.google.maps.DirectionsStatus.OK) {
                //console.log(result);
            } else {
                console.error(`error fetching directions ${result}`);
            }
        });
    }

    render() {
        const { classes } = this.props;
        return (
            <Grid container spacing={24}>
                <Grid item xs={12} sm={8} >
                    <MyMapComponent
                        mapParcours={this.props.mapParcours}
                        directions={this.props.directions}
                        directions2={this.props.directions2}
                        audit_selected={this.props.audit_selected}
                        lat={this.props.lat}
                        lng={this.props.lng}
                        zoom={this.props.zoom}
                        audits={this.props.audits}
                        isMarkerShown={true}
                        onMarkerClick={this.props.handleMarkerClick}
                        onCenterChanged={this.props.handleCenterChanged}
                        onZoomChanged={this.props.handleZoomChanged}
                    />

                    <Grid container spacing={24}>
                        <Grid item xs={12} sm={6} >
                            <ValidatorForm onSubmit={this.props.handleFormSubmit} className={this.props.classes.form} style={{margin: 0}}>
                                <LocationSearchInput label="Adresse de départ" address={this.props.from.address} handleInputChange={(e) => this.props.handleAddressChange(e, 'from')} />
                            </ValidatorForm>
                        </Grid>
                        <Grid item xs={12} sm={6} >
                            <ValidatorForm onSubmit={this.props.handleFormSubmit} className={this.props.classes.form} style={{margin: 0}}>
                                <LocationSearchInput label="Adresse d'arrivée" address={this.props.to.address} handleInputChange={(e) => this.props.handleAddressChange(e, 'to')} />
                            </ValidatorForm>
                        </Grid>
                        <Grid item xs={12} sm={6} >
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Mode de trajet :</FormLabel>
                                <RadioGroup
                                    aria-label="mode"
                                    name="mode"
                                    value={this.props.travelMode}
                                    onChange={this.props.handleChangeTravelMode}
                                    row
                                >
                                    <FormControlLabel
                                        value="Driving"
                                        control={<Radio color="primary" />}
                                        label="Voiture"
                                        labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        value="Bicycling"
                                        control={<Radio color="primary" />}
                                        label="Vélo"
                                        labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        value="Walking"
                                        control={<Radio color="primary" />}
                                        label="À pied"
                                        labelPlacement="end"
                                    />
                                    {/*<FormControlLabel
                                        value="Transit"
                                        control={<Radio color="primary" />}
                                        label="Transport"
                                        labelPlacement="end"
                                    />*/}
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} >
                            <FormControl component="fieldset">
                                <Button variant="contained" color="primary" className={classes.button} onClick={()=>this.props.searchDirection(this.props.audits)}>
                                    Générer le trajet
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={4} >
                    <SwipeableViews
                        axis={'x'}
                        index={this.props.seeMore ? 1 : 0}
                    >
                        <div dir={'ltr'} className={classes.divSwip}>
                            <div>
                            <DateRange dateStart={this.props.dateStart} dateEnd={this.props.dateEnd} onChangeDateRange={this.props.onChangeDateRange}/>
                            <List className={classes.list}>
                                {this.props.audits.map(audit => (
                                    <ListItem button key={audit.id} className={this.props.audit_selected === audit.id ? classes.selected : ""} alignitems="flex-start" onClick={() => this.props.handleMarkerClick(audit, true)}>
                                        <ListItemText
                                            primary={" Ent. " + audit.company.name}
                                            secondary={
                                                <React.Fragment>
                                                    <Typography component="span" color="textPrimary">
                                                        {moment(audit.date).format("DD/MM/YYYY à HH:mm")}
                                                    </Typography>
                                                    {audit.address}
                                                    <Button size="small" className={classes.button} style={{margin: 0}} onClick={() => this.props.onSeeMore(audit.id)}>
                                                        Voir les détails...
                                                    </Button>
                                                </React.Fragment>
                                            }
                                        />
                                    </ListItem>
                                ))}
                            </List>
                            </div>
                        </div>
                        <div dir={'ltr'} className={classes.divSwip}>
                            {this.props.seeMore && (
                                <Grid container spacing={24}>
                                    <Grid item xs={12} style={{margin: 0}}>
                                        <Button variant="outlined" className={classes.button} style={{margin: 0}} onClick={() => this.props.onSeeMore(null)}>
                                            {"< Retour"}
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography component="span" color="textPrimary">
                                            {" Entreprise " + this.props.seeMore.company.name}
                                        </Typography>
                                        <Typography component="span" color="textPrimary">
                                            {(() => {
                                                switch(this.props.seeMore.status) {
                                                    case 'waiting':
                                                        return "État : En attente";
                                                    case 'appointment':
                                                        return "État : Rendez-vous validé";
                                                    case 'valid':
                                                        return "État : Validé";
                                                    case 'issue':
                                                        return "État : Écart";
                                                    case 'reject':
                                                        return "État : Rejeté";
                                                    default:
                                                        return null;
                                                }
                                            })()}
                                        </Typography>
                                        <Typography component="span" color="textPrimary">
                                            {"Le : " + moment(this.props.seeMore.date).format("DD/MM/YYYY à HH:mm")}
                                        </Typography>
                                        <Typography component="span" color="textPrimary">
                                            {"Chez : " + this.props.seeMore.client}
                                        </Typography>
                                        <Typography component="span" color="textPrimary">
                                            {"À l'adresse : " + this.props.seeMore.address}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <MuiPickersUtilsProvider locale="fr" moment={moment} utils={MomentUtils}>
                                            <ValidatorForm onSubmit={this.props.handleFormSubmit} className={this.props.classes.form}>
                                                <FormControl margin="normal" fullWidth>
                                                    <Picker
                                                        label="Date"
                                                        onChange={this.props.editAudit}
                                                        name="date"
                                                        value={this.props.seeMore.date}
                                                        format="DD/MM/YYYY HH:mm"
                                                    />
                                                    {!this.props.user.google_access_token_expire_at && (
                                                        <div>
                                                            <Typography variant="subheading" color="secondary">La synchronisation "Google Agenda" est désactivé !</Typography>
                                                            <NavLink to={"/account/"} >Activer la synchronisation</NavLink>
                                                        </div>
                                                    )}
                                                </FormControl>
                                            </ValidatorForm>
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                </Grid>
                            )}
                        </div>
                    </SwipeableViews>


                </Grid>
                <Grid item xs={12} >
                    <Scheduler
                        audits={this.props.audits}
                        directions={this.props.directions}
                        handleMarkerClick={this.props.handleMarkerClick}
                        optimized_waypoint_order={this.props.optimized_waypoint_order}
                    />
                </Grid>
            </Grid>
        )
    }
}

Parcours.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Parcours);



// WEBPACK FOOTER //
// ./src/component/map/parcours.js